"use client";

import { useEffect, useState } from "react";
import Badge from "@mui/material/Badge";
import useCart from "hooks/useCart";
import IconComponent from "@/components/IconComponent";

import { StyledNavLink, Wrapper } from "./styles";

export default function MobileNavigationBar({ navigation }) {
  const { state } = useCart();

  const [showBar, setShowBar] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  const handleScroll = () => {
    const currentScrollY = window.scrollY;
    const windowHeight = window.innerHeight;
    const fullHeight = document.documentElement.scrollHeight;

    if (currentScrollY + windowHeight >= fullHeight - 5) {
      setShowBar(false);
    } else if (currentScrollY > lastScrollY && currentScrollY > 50) {
      setShowBar(false);
    } else {
      setShowBar(true);
    }

    setLastScrollY(currentScrollY);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  const quantity = state.cart.reduce((acc, item) => acc + item.qty, 0);

  return (
    <Wrapper
      style={{
        transform: showBar ? "translateY(0%)" : "translateY(100%)",
        transition: "transform 0.3s ease-in-out",
      }}
    >
      {navigation.map(({ icon, href, title, badge }) => (
        <StyledNavLink prefetch={false} href={href} key={title}>
          {badge ? (
            <Badge badgeContent={quantity} color="primary">
              <IconComponent icon={icon} fontSize="small" className="icon" />
            </Badge>
          ) : (
            <IconComponent icon={icon} fontSize="small" className="icon" />
          )}
          {title}
        </StyledNavLink>
      ))}
    </Wrapper>
  );
}
